import { Vector2, Vector3, Vector4, Matrix } from "../Maths/math.vector.js";
import { Color3, Color4 } from "../Maths/math.color.js";
export const RichTypeAny = {
    typeName: "any",
    defaultValueBuilder: () => undefined,
};
export const RichTypeString = {
    typeName: "string",
    defaultValueBuilder: () => "",
};
export const RichTypeNumber = {
    typeName: "number",
    defaultValueBuilder: () => 0,
};
export const RichTypeBoolean = {
    typeName: "boolean",
    defaultValueBuilder: () => false,
};
export const RichTypeVector2 = {
    typeName: "Vector2",
    defaultValueBuilder: () => Vector2.Zero(),
};
export const RichTypeVector3 = {
    typeName: "Vector3",
    defaultValueBuilder: () => Vector3.Zero(),
};
export const RichTypeVector4 = {
    typeName: "Vector4",
    defaultValueBuilder: () => Vector4.Zero(),
};
export const RichTypeMatrix = {
    typeName: "Matrix",
    defaultValueBuilder: () => Matrix.Identity(),
};
export const RichTypeColor3 = {
    typeName: "Color3",
    defaultValueBuilder: () => Color3.Black(),
};
export const RichTypeColor4 = {
    typeName: "Color4",
    defaultValueBuilder: () => new Color4(0, 0, 0, 0),
};
//# sourceMappingURL=flowGraphRichTypes.js.map